// extracted by mini-css-extract-plugin
export default {"container":"ColorectalCancerScreening_container__znk2Q","back-btn":"ColorectalCancerScreening_back-btn__CIZaU","back-icon":"ColorectalCancerScreening_back-icon__4oQNS"};